import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Layout from "components/structure/Layout";
import React, { useContext, useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import CommonService from "services/CommonService";
import RoleService from "services/RoleService";
import CheckboxTick from "assets/CheckboxTick.svg";
import CheckboxUntick from "assets/CheckboxUntick.svg";
import { AuthData } from "auth/AuthWarpper";
import { useLocation, useNavigate } from "react-router-dom";
import { SnackbarContext } from "context/snackBarContext";
import UserService from "services/UserService";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import UserCreationService from "services/UserCreationService";
import ExportService from "services/ExportService";
import { formatISO } from "date-fns";

const Export = () => {
  const location = useLocation();
  const profileOptions = ["Global", "Local"];
  const { user } = AuthData();
  const navigate = useNavigate();
  const { rowData } = location.state || {};
  console.log("🚀 ~ Export ~ rowData:", location?.state);
  console.log("profileName", user?.profileName);

  const { setOpenAlert, setSeverity, setMessage, handleClose } =
    useContext(SnackbarContext);
  const [userName, setUserName] = useState(rowData?.userName || "");
  const [isActive, setIsActive] = useState(
    rowData?.active === "Active" ? "Active" : "InActive"
  );

  const [formData, setFormData] = useState({
    profile: rowData?.batOneId || "",
    fieldTechnician: "",
    role: rowData?.profileId || "",
    serviceNumber: rowData?.serviceNumber || "",
    remarks: rowData?.remarks || "",
    countryCode: rowData?.countryCode || "",
    status: "",
    globalLocal: "",
  });
  const [selected, setSelected] = useState([]);
  console.log("🚀 ~ Export ~ selected:", selected);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = React.useState(false);
  const [StartDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedValue, setSelectedValue] = useState("3");
  const [todayDate, setTodayDate] = useState(new Date());
  const [calculatedDate, setCalculatedDate] = useState("");

  const [roleOptions, setRoleOptions] = useState([]);
  const [countries, setCountries] = useState([]);

  const fetchRoles = async () => {
    try {
      let response;
      if (location.state == "administrator") {
        response = await RoleService.getActiveRolesAdministrator();
      } else {
        response = await RoleService.getActiveRoles();
      }
      if (response.data?.statusCode === 200) {
        setRoleOptions(response.data.response);
      } else {
        console.error("Error fetching roles:", response.data.message);
      }
    } catch (error) {
      console.error("API call error:", error);
    }
  };

  const fetchCountries = async () => {
    try {
      const response = await CommonService.fetchCountries();
      if (response.data?.statusCode === 200) {
        setCountries(response.data.response);
      } else {
        console.error("Error fetching roles:", response.data.message);
      }
    } catch (error) {
      console.error("API call error:", error);
    }
  };

  useEffect(() => {
    fetchRoles();
    fetchCountries();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const isAllSelected =
    countries.length > 0 && selected.length === countries.length;

  const handleChangeCountry = (event) => {
    const value = event.target.value;
    setSelected(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // setErrors({});
      // await validationSchema.validate(formData, { abortEarly: false });

      // Constructing the payload object
      const payload = {
        userName: userName,
        active: isActive === "Active" ? true : false,
        batOneId: formData.profile,
        // profileAttribute: formData.profile,s
        serviceNumber: formData.serviceNumber,
        startDate: new Date().toISOString(),
        endDate: StartDate,
        remarks: formData.remarks,
        isDeleted: false,
        email: "",
        profileId: formData.role,
        countryCode: formData.countryCode,
        createdByUser: user.userName,
        modifiedByUser: user.userName,
        createdDateTimeUTC: new Date().toISOString(),
        modifiedDateTimeUTC: new Date().toISOString(),
      };

      // userId

      // "userName": "Rahul Dutta",
      // "profileId": "99247bae-e30a-4106-b198-e74e2ce55d26",
      // "batOneId": 85189949,
      // "countryCode": "KEN",
      // "email": "rahul.dutta@itcinfotech.com",
      // "active": true,
      // "isDeleted": false,
      // "createdDateTimeUTC": "2024-05-14T09:32:51.543Z",
      // "createdByUser": "ADMIN",
      // "modifiedDateTimeUTC": "2024-10-04T11:19:29.590Z",
      // "modifiedByUser": "Rahul Dutta"

      // Make a POST request using Axios
      const response = await UserCreationService.createUserManagement(payload);

      if (response.status === 201) {
        // Show success snackbar
        navigate("/userCreation");
        setSeverity("success");
        setMessage("Added successfully");
        setOpenAlert(true);
        setLoading(false);
      } else {
        console.error("Failed to submit form");
        // Show error snackbar
        setSeverity("error");
        setMessage("Failed to submit form");
        setOpenAlert(true);
      }
    } catch (error) {
      let newError = {};
      if (error?.name && error.name === "ValidationError") {
        error?.inner?.forEach((err) => {
          newError[err.path] = err.message;
          setErrors(newError || error?.message);
          return;
        });
      } else {
        setSeverity("error");
        setMessage(error?.response?.data?.message || error?.message);
        setOpenAlert(true);
      }
      setLoading(false);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    // setLoading(true);
    try {
      // setErrors({});
      // await validationSchema.validate(formData, { abortEarly: false });

      // Constructing the payload object
      const payload = {
        userId: rowData?.userId,
        userName: userName,
        active: isActive === "Active" ? true : false,
        batOneId: formData.profile,
        // profileAttribute: formData.profile,s
        serviceNumber: formData.serviceNumber,
        startDate: new Date().toISOString(),
        endDate: StartDate,
        remarks: formData.remarks,
        isDeleted: false,
        email: "",
        profileId: formData.role,
        countryCode: formData.countryCode,
        createdByUser: user?.userName || "Rahul",
        modifiedByUser: user?.userName || "Rahul",
        createdDateTimeUTC: new Date().toISOString(),
        modifiedDateTimeUTC: new Date().toISOString(),
      };

      // userId

      // "userName": "Rahul Dutta",
      // "profileId": "99247bae-e30a-4106-b198-e74e2ce55d26",
      // "batOneId": 85189949,
      // "countryCode": "KEN",
      // "email": "rahul.dutta@itcinfotech.com",
      // "active": true,
      // "isDeleted": false,
      // "createdDateTimeUTC": "2024-05-14T09:32:51.543Z",
      // "createdByUser": "ADMIN",
      // "modifiedDateTimeUTC": "2024-10-04T11:19:29.590Z",
      // "modifiedByUser": "Rahul Dutta"

      // Make a POST request using Axios
      const response = await UserCreationService.updateUserManagement(payload);

      if (response.status === 200) {
        // Show success snackbar
        navigate("/userCreation");
        setSeverity("success");
        setMessage("Updated successfully");
        setOpenAlert(true);
        setLoading(false);
      } else {
        console.error("Failed to submit form");
        // Show error snackbar
        setSeverity("error");
        setMessage("Failed to submit form");
        setOpenAlert(true);
      }
    } catch (error) {
      let newError = {};
      if (error?.name && error.name === "ValidationError") {
        error?.inner?.forEach((err) => {
          newError[err.path] = err.message;
          setErrors(newError || error?.message);
          return;
        });
      } else {
        setSeverity("error");
        setMessage(error?.response?.data?.message || error?.message);
        setOpenAlert(true);
      }
      setLoading(false);
    }
  };

  const [profileData, setProfileData] = useState([]);

  const handleChangeText = (e) => {
    setFormData({ ...formData, profile: e.target.value });
  };

  const [batData, setBatData] = useState("");

  const [open, setOpen] = useState(false);
  const [openEnd, setOpenEnd] = useState(false);

  useEffect(() => {
    const fetchProfileData = async () => {
      if (formData.profile) {
        try {
          const response = await UserService.FindAdUser(formData.profile);

          setBatData(response?.data?.response);
          setUserName(
            `${response?.data?.response?.givenName ?? ""} ${
              response?.data?.response?.surName ?? ""
            }`.trim()
          );

          // Assuming the response contains a list of options in response.data
        } catch (error) {
          console.error("Error fetching profile data:", error);
        }
      }
    };

    fetchProfileData();
  }, [formData.profile]);

  const toggleIsActive = () => {
    setIsActive((prevIsActive) =>
      prevIsActive === "Active" ? "InActive" : "Active"
    );
  };

  const handleChangeDate = (date) => {
    setStartDate(dayjs(date)); // Store the selected date
    setSelectedValue("");
    setTodayDate("");
    setCalculatedDate("");
  };

  const handleChangeDateEnd = (date) => {
    setEndDate(date); // Store the selected date
    setSelectedValue("");
    setTodayDate("");
    setCalculatedDate("");
  };

  // Function to calculate and set the calculated date
  const calculateDate = (months) => {
    const date = new Date(todayDate);
    date?.setMonth(todayDate?.getMonth() - months);
    const formattedDate = formatISO(date);
    setCalculatedDate(formattedDate);
  };

  useEffect(() => {
    // Set today's date in ISO format when component mounts
    setTodayDate(new Date());

    // Calculate date for the default selected value (3 months)
    calculateDate(3); // Calculate for 3 months on initial render
  }, []);

  const handleChangeRadio = (event) => {
    const value = event.target.value;
    setSelectedValue(value);
    setStartDate(null);
    setEndDate(null);

    // Calculate the date based on the selected value
    calculateDate(parseInt(value)); // Convert value to number for calculation
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  // Handles opening the menu
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Handles closing the menu
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  // Function to handle export option clicks

  const buttonRef = useRef(null);

  const extractTime = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[1].split(".")[0]; // Extract time in HH:mm:ss format
  };

  const extractDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0]; // Extract only the date part in YYYY-MM-DD format
  };

  const filterArrayByKeys = (arrayB, arrayA) => {
    return arrayB.map((item) => {
      return Object.keys(item)
        .filter((key) => arrayA.includes(key)) // Retain only keys that exist in Array A
        .reduce((obj, key) => {
          obj[key] = item[key]; // Build a new object with only these keys
          return obj;
        }, {});
    });
  };

  const isCountryArray = (arr) => {
    return (
      Array.isArray(arr) &&
      arr.length > 0 &&
      arr.every((item) => item.countryName)
    );
  };

  const generateCsvContent = (headerMapping, csvData) => {
    // Get headers from the mapping
    const rows = csvData.split("\n");

    const originalHeaders = rows[0].split(",");
    const newHeaders = originalHeaders.map((header) =>
      headerMapping[header] ? headerMapping[header] : header
    );

    // Reassemble the CSV with the new headers
    const csvWithNewHeaders = [newHeaders.join(","), ...rows.slice(1)].join(
      "\n"
    );

    return csvWithNewHeaders;
  };

  const handleExport = async (format) => {
    try {
      // Check if XLSX is defined
      if (!XLSX) {
        console.error("XLSX library is not loaded.");
        return;
      }
      const todayDateISO = todayDate ? todayDate.toISOString() : ""; // Only format if todayDate exists
      const actualFormatTodayDate = todayDateISO ? dayjs(todayDateISO) : "";

      // const calculatedDateISO = calculatedDate ? calculatedDate : ''; // Same for calculatedDate
      const actualFormatCalculatedDate = calculatedDate
        ? dayjs(calculatedDate)
        : "";

      const countryCodeArray = selected.map((item) => item.countryCode);

      const countryCode = countryCodeArray;

      const { role, status } = formData; // Destructure startDate and endDate from formData
      let response;
      if (location.state == "user") {
        response = await ExportService.getExport({
          startDate: actualFormatCalculatedDate || StartDate, // Fallback to startDate if todayDateISO is empty
          endDate: actualFormatTodayDate || endDate, // Fallback to endDate if calculatedDate is empty
          role,
          status,
          countryCode,
        });
      } else if (location.state == "userAdmin") {
        response = await ExportService.getExportUserAdmin({
          startDate: actualFormatCalculatedDate || StartDate, // Fallback to startDate if todayDateISO is empty
          endDate: actualFormatTodayDate || endDate, // Fallback to endDate if calculatedDate is empty
          role,
          status,
          countryCode,
        });
      } else if (location.state == "administrator") {
        response = await ExportService.getAdministratorRole({
          startDate: actualFormatCalculatedDate || StartDate, // Fallback to startDate if todayDateISO is empty
          endDate: actualFormatTodayDate || endDate, // Fallback to endDate if calculatedDate is empty
          role,
          status,
          countryCode,
          attribute: formData.globalLocal,
        });
      } else {
        response = await ExportService.getExportRole({
          startDate: actualFormatCalculatedDate || StartDate, // Fallback to startDate if todayDateISO is empty
          endDate: actualFormatTodayDate || endDate, // Fallback to endDate if calculatedDate is empty
          role,
          status,
          countryCode,
          attribute: formData.globalLocal,
        });
      }

      // API call to get data
      // Extract the 'response' array from the API response
      const exportData = response.data.response;

      // Check if there is data to export
      if (exportData && exportData.length > 0) {
        // Get the current date and time in YYYY-MM-DD_HH-MM-SS format
        const today = new Date();
        const formattedDate = today.toISOString().split("T")[0]; // YYYY-MM-DD
        const formattedTime = today
          .toTimeString()
          .split(" ")[0]
          .replace(/:/g, "-"); // HH-MM-SS
        const filename = `exportData_${formattedDate}_${formattedTime}`; // Combine date and time

        if (format === "csv") {
          // Generate CSV content
          let headers = [];
          let actualHeader = [];

          if (location.state === "role" || location.state === "administrator") {
            actualHeader = [
              "Role Name",
              "Role Owner",
              "Created By",
              "Assigned Functionalities",
              "Creation Date",
              "Country",
              "Status(Active?Yes/No)",
              "Attribute(Local/Global)",
            ];
            headers = [
              "profileName",
              "profileOwnerName",
              "createdByUser",
              "functionalities",
              "createdDateTimeUTC",
              "countries",
              "isActive",
              "profileAttribute",
            ];
          } else if (location.state === "userAdmin" || location.state === "user") {
            actualHeader = [
              "One Id",
              "User name",
              "Role Name",
              "Created By",
              "Creation Date",
              "Start Date",
              "End Date",
              "Country",
              "Status(Active?Yes/No)",
              "Access Removal Date",
              "Last Login Date",
            ];
            headers = [
              "batOneId",
              "userName",
              "profileName",
              "createdByUser",
              "createdDateTimeUTC",
              "startDate",
              "endDate",
              "countryName",
              "active",
              "accessRemovalDate",
              "lastLoginDate",
            ];
          } else {
            headers = [
              "userName",
              "createdByUser",
              "profileName",
              "countries",
              "batOneId",
              "startDate",
              "endDate",
              "isActive",
            ];
          }

          let headersForITAdmin = [
            "userName",
            "profileAttribute",
            "createdByUser",
            "countries",
            "batOneId",
            "startDate",
            "startTime",
            "endDate",
            "endTime",
            "isActive",
          ];

          let rows = [];
          let updatedExportData = exportData.map((item) => ({
            ...item,
            functionalities: item?.functionalities
              ?.map((functionality) => functionality.functionality_name)
              .join("/ "), // Convert array of functionality names to a single string
          }));
          console.log(
            "🚀 ~ updatedExportData ~ updatedExportData:",
            exportData
          );

          if (location.state === "user" && user.profileName === "IT Admin") {
            rows = exportData.map((item) => {
              const newItem = {};

              // Map keys for IT Admin
              headersForITAdmin.forEach((key) => {
                if (key === "startTime") {
                  newItem[key] = item?.startDate
                    ? extractTime(item.startDate)
                    : "";
                } else if (key === "endTime") {
                  newItem[key] = item?.endDate ? extractTime(item.endDate) : "";
                } else if (key === "startDate") {
                  newItem[key] = item?.startDate
                    ? extractDate(item.startDate)
                    : "";
                } else if (key === "endDate") {
                  newItem[key] = item?.endDate ? extractDate(item.endDate) : "";
                } else if (key === "isActive") {
                  newItem[key] = item[key] ? "Yes" : "No"; // Convert true/false to Yes/No
                } else {
                  newItem[key] = item[key]; // Add other keys
                }
              });

              return newItem;
            });
          }

          let csvContent = [];
          if (location.state === "user" && user.profileName === "IT Admin") {
            csvContent = [
              headersForITAdmin.join(","), // Join headers with commas
              ...rows.map((row) =>
                headersForITAdmin.map((header) => row[header]).join(",")
              ), // Join row values
            ].join("\n"); // Separate rows by newlines
          } else {
            csvContent = [
              headers.join(","), // Join headers with commas
              ...updatedExportData.map((row) =>
                headers
                  .map((header) => {
                    if (header === "countries" && Array.isArray(row[header])) {
                      return row[header]
                        .map((country) => country.countryName)
                        .join("/");
                    } else if (header === "isActive") {
                      return row[header] ? "Yes" : "No"; // Convert true/false to Yes/No
                    }
                    else if (header === "active") {
                      return row[header] ? "Yes" : "No"; // Convert true/false to Yes/No
                    }
                    return row[header]; // For other fields, return the value
                  })
                  .join(",")
              ),
            ].join("\n"); // Separate rows by newlines
          }


          const headerMapping = {
            batOneId: "One Id",
            userName: "User Name",
            profileName: "Role Name",
            profileOwnerName: "Role Owner",
            createdByUser: "Created By",
            functionalities: "Assigned Functionalities",
            createdDateTimeUTC: "Creation Date",
            countryName: "Country",
            countries: "Country",
            isActive: "Status(Active?Yes/No)",
            active:"Status(Active?Yes/No)",
            profileAttribute: "Attribute(Local/Global)",
            startDate: "Start Date",
            endDate: "End Date",
            accessRemovalDate: "Access Removal Date",
            lastLoginDate: "Last Login Date",
          };

          let getActualDataForScv = generateCsvContent(
            headerMapping,
            csvContent
          );

          // Create a Blob and download the CSV file
          const blob = new Blob([getActualDataForScv], {
            type: "text/csv;charset=utf-8;",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${filename}.${format}`); // Use formatted filename
          document.body.appendChild(link);
          link.click();
        } else if (format === "vnd.ms-excel") {
          try {
            let headers = [];
            let newRows = [];
            let actualHeader = [];
            // if (location.state == "role") {
            //   headers = [
            //     "profileName",
            //     "profileOwnerName",
            //     "roleFunctionality",
            //     "createdDateTimeUTC",
            //     "countries",
            //     "isActive",
            //   ];
            // }
            if (
              location.state == "administrator" ||
              location.state === "role"
            ) {
              actualHeader = [
                "Role Name",
                "Role Owner",
                "Created By",
                "Assigned Functionalities",
                "Creation Date",
                "Country",
                "Status(Active?Yes/No)",
                "Attribute(Local/Global)",
              ];
              headers = [
                "profileName",
                "profileOwnerName",
                "createdByUser",
                "functionalities",
                "createdDateTimeUTC",
                "countries",
                "isActive",
                "profileAttribute",
              ];
            } 
            else if (location.state === "userAdmin" || location.state == "user") {
              actualHeader = [
                "One Id",
                "User name",
                "Role Name",
                "Created By",
                "Creation Date",
                "Start Date",
                "End Date",
                "Country",
                "Status(Active?Yes/No)",
                "Access Removal Date",
                "Last Login Date",
              ];
              headers = [
                "batOneId",
                "userName",
                "profileName",
                "createdByUser",
                "createdDateTimeUTC",
                "startDate",
                "endDate",
                "countryName",
                "active",
                "accessRemovalDate",
                "userLastLoginDate",
              ];
            }
             else {
              headers = [
                "userName",
                "createdByUser",
                "profileName",
                "countries",
                "batOneId",
                "startDate",
                "endDate",
                "isActive",
              ];
            }
            let headersForITAdmin = [
              "userName",
              "profileAttribute",
              "createdByUser",
              "countries",
              "batOneId",
              "startDate",
              "startTime",
              "endDate",
              "endTime",
              "isActive",
            ];
            let rows = [];

            let updatedExportData = exportData.map((item) => ({
              ...item,
              functionalities: item?.functionalities
                ?.map((functionality) => functionality.functionality_name)
                .join("/ "), // Convert array of functionality names to a single string
            }));

            if (location.state == "user" && user.profileName == "IT Admin") {
              rows = exportData.map((item) => {
                const newItem = {};

                // Pick only the keys from Array A
                headersForITAdmin.forEach((key) => {
                  if (key === "startTime") {
                    if (item?.startDate) {
                      newItem[key] = extractTime(item.startDate); // Add startTime from startDate
                    }
                  } else if (key === "endTime") {
                    if (item?.endDate) {
                      newItem[key] = extractTime(item.endDate); // Add endTime from endDate
                    }
                  } else if (key === "startDate") {
                    if (item?.startDate) {
                      newItem[key] = extractDate(item.startDate); // Add startTime from startDate
                    }
                  } else if (key === "endDate") {
                    if (item?.endDate) {
                      newItem[key] = extractDate(item.endDate); // Add startTime from startDate
                    }
                  } else {
                    newItem[key] = item[key]; // Add the rest of the keys from Array B
                  }
                });

                return newItem;
              });
            } else {
              rows = filterArrayByKeys(updatedExportData, headers);

              rows.forEach((row) => {
                const keys = Object.keys(row);
                let newObj = {};
                keys.forEach((key) => {
                  if (key == "profileName") {
                    newObj = { ...newObj, ["Role Name"]: row[key] };
                  }
                  if (key == "userName") {
                    newObj = { ...newObj, ["User Name"]: row[key] };
                  }
                  if (key == "batOneId") {
                    newObj = { ...newObj, ["One Id"]: row[key] };
                  }
                  if (key == "startDate") {
                    newObj = { ...newObj, ["Start Date"]: row[key] };
                  }
                  if (key == "endDate") {
                    newObj = { ...newObj, ["End Date"]: row[key] };
                  }
                  if (key == "countryName") {
                    newObj = { ...newObj, ["Country"]: row[key] };
                  }
                  if (key == "accessRemovalDate") {
                    newObj = { ...newObj, ["Access Removal Date"]: row[key] };
                  }
                  if (key == "userLastLoginDate") {
                    newObj = { ...newObj, ["Last Login Date"]: row[key] };
                  }

                  if (key == "profileOwnerName") {
                    newObj = { ...newObj, ["Role Owner"]: row[key] };
                  }
                  if (key == "createdByUser") {
                    newObj = { ...newObj, ["Created By"]: row[key] };
                  }
                  if (key == "profileAttribute") {
                    newObj = {
                      ...newObj,
                      ["Attribute(Local/Global)"]: row[key],
                    };
                  }
                  if (key == "functionalities") {
                    newObj = {
                      ...newObj,
                      ["Assigned Functionalities"]: row[key],
                    };
                  }
                  if (key == "createdDateTimeUTC") {
                    newObj = { ...newObj, ["Creation Date"]: row[key] };
                  }
                  if (key == "countries") {
                    let countryArray = row[key];
                    let countryString = countryArray
                      .map((country) => country.countryName)
                      .join(" / ");

                    newObj = { ...newObj, ["Country"]: countryString };
                  }
                  if (key == "isActive") {
                    newObj = {
                      ...newObj,
                      ["Status(Active?Yes/No)"]: row[key] ? "Yes" : "No",
                    };
                  }
                  if (key == "active") {
                    newObj = {
                      ...newObj,
                      ["Status(Active?Yes/No)"]: row[key] ? "Yes" : "No",
                    };
                  }
                });
                newRows.push(newObj);
              });
            }
            const ws = XLSX.utils.json_to_sheet(newRows); // Convert JSON to sheet
            const wb = XLSX.utils.book_new(); // Create a new workbook
            XLSX.utils.book_append_sheet(wb, ws, "Users"); // Append sheet to workbook
            XLSX.writeFile(wb, `${filename}.xlsx`); // Use formatted filename
          } catch (error) {
            console.error("Error generating Excel file:", error);
          }
        } else if (format === "pdf") {
          let updatedExportData = exportData.map((item) => ({
            ...item,
            functionalities: item?.functionalities
              ?.map((func) => func.functionality_name)
              .join("/ "), // Convert functionalities array to string
            roleFunctionality: item?.roleFunctionality?.join("/ "), // Convert roleFunctionality array to string
          }));
          // Generate PDF file
          const doc = new jsPDF();
          // doc.text('Main Header', 105, 20, { align: 'center' });
          // doc.text("Users Data", 20, 10);

          // Prepare data for PDF
          // const headers = Object.keys(exportData[0]);
          let headers = [];
          let actualHeader = [];
          // if (location.state == "role") {
          //   actualHeader = [
          //     "Role Name",
          //     "Role Owner",
          //     "Assigned Functionalities",
          //     "Creation Date",
          //     "Country",
          //     "Status(Active?Yes/No)",
          //   ];
          //   headers = [
          //     "profileName",
          //     "profileOwnerName",
          //     "roleFunctionality",
          //     "createdDateTimeUTC",
          //     "countries",
          //     "isActive",
          //   ];
          // } else
          if (location.state == "administrator" || location.state == "role") {
            actualHeader = [
              "Role Name",
              "Role Owner",
              "Created By",
              "Assigned Functionalities",
              "Creation Date",
              "Country",
              "Status",
              "Attribute",
            ];
            headers = [
              "profileName",
              "profileOwnerName",
              "createdByUser",
              "functionalities",
              "createdDateTimeUTC",
              "countries",
              "isActive",
              "profileAttribute",
            ];
          }
          else if (location.state === "userAdmin" || location.state == "user") {
            actualHeader = [
              "One Id",
              "User name",
              "Role Name",
              "Created By",
              "Creation Date",
              "Start Date",
              "End Date",
              "Country",
              "Status(Active?Yes/No)",
              "Access Removal Date",
              "Last Login Date",
            ];
            headers = [
              "batOneId",
              "userName",
              "profileName",
              "createdByUser",
              "createdDateTimeUTC",
              "startDate",
              "endDate",
              "countryName",
              "active",
              "accessRemovalDate",
              "lastLoginDate",
            ];
          }
          else {
            headers = [
              "userName",
              "createdByUser",
              "profileAttribute",
              "countryName",
              "batOneId",
              "startDate",
              "endDate",
              "isActive",
            ];
          }
          let headersForITAdmin = [
            "userName",
            "profileAttribute",
            "createdByUser",
            "countryName",
            "batOneId",
            "startDate",
            "startTime",
            "endDate",
            "endTime",
            "isActive",
          ];
          let rows = [];
          if (location.state == "user" && user.profileName == "IT Admin") {
            rows = exportData.map((item) => {
              return headersForITAdmin.map((key) => {
                if (key === "startTime") {
                  if (item?.startDate) {
                    return extractTime(item.startDate); // Extract startTime from startDate
                  }
                } else if (key === "endTime") {
                  if (item?.endDate) {
                    return extractTime(item.endDate); // Extract endTime from endDate
                  }
                } else if (key === "startDate") {
                  if (item?.startDate) {
                    return extractDate(item.startDate); // Extract only the date part of startDate
                  }
                } else if (key === "endDate") {
                  if (item?.endDate) {
                    return extractDate(item.endDate); // Extract only the date part of endDate
                  }
                } else if (key === "isActive") {
                  return item[key] ? "Yes" : "No";
                } else {
                  return item[key]; // Return the value for the corresponding key
                }
              });
            });
          } else {
            rows = updatedExportData.map((row) =>
              headers.map((header) => {
                if (header === "isActive") {
                  return row[header] ? "Yes" : "No"; // Convert true/false to Yes/No
                }
                if (header === "active") {
                  return row[header] ? "Yes" : "No"; // Convert true/false to Yes/No
                }
                return row[header]; // Return the value for the corresponding key
              })
            );
          }

          let modifiedArrayWithCountry = [];
          rows.forEach((data) => {
            data.forEach((item, index) => {
              if (isCountryArray(item)) {
                // If the item is the country array, join country names and replace the array
                data[index] = item
                  .map((country) => country.countryName)
                  .join(" / ");
                modifiedArrayWithCountry.push(data);
              }
            });
          });
          // Use autoTable for formatting
          doc.autoTable({
            head: [
              location.state == "user" && user.profileName == "IT Admin"
                ? headersForITAdmin
                : actualHeader,
            ],
            body: rows,
          });

          doc.save(`${filename}.${format}`); // Use formatted filename
        }
      } else {
        setMessage("No data available for export");
        setOpenAlert(true);
        setSeverity("error");
        console.error("No data available for export");
      }
    } catch (error) {
      console.error("Export failed", error);
      console.error("Error fetching data:sss", error?.response?.data?.message);
      setMessage(error?.response?.data?.message || error?.message);
      setOpenAlert(true);
      setSeverity("error");
    }

    handleClose();
  };

  // const handleExport = async (format) => {
  //   try {
  //     // API call to get data
  //     const { role, status, countryCode } = formData;
  //     const response = await ExportService.getExport({
  //       StartDate,
  //       endDate,
  //       role,
  //       status,
  //       countryCode,
  //     });

  //     // Extract the 'response' array from the API response
  //     const exportData = response.data.response;
  //     console.log("🚀 ~ handleExport ~ exportData:", exportData);

  //     // Check if there is data to export
  //     if (exportData && exportData.length > 0) {
  //       // Get the current date and time in YYYY-MM-DD_HH-MM-SS format
  //       const today = new Date();
  //       const formattedDate = today.toISOString().split("T")[0]; // YYYY-MM-DD
  //       const formattedTime = today
  //         .toTimeString()
  //         .split(" ")[0]
  //         .replace(/:/g, "-"); // HH-MM-SS
  //       const filename = `users_${formattedDate}_${formattedTime}`; // Combine date and time

  //       if (format === "csv") {
  //         // Generate CSV content
  //         const headers = Object.keys(exportData[0]);
  //         const csvContent = [
  //           headers.join(","), // Join headers with commas
  //           ...exportData.map((row) =>
  //             headers.map((header) => row[header]).join(",")
  //           ), // Join row values
  //         ].join("\n"); // Separate rows by newlines

  //         // Create a Blob and download the CSV file
  //         const blob = new Blob([csvContent], {
  //           type: "text/csv;charset=utf-8;",
  //         });
  //         const url = window.URL.createObjectURL(blob);
  //         const link = document.createElement("a");
  //         link.href = url;
  //         link.setAttribute("download", `${filename}.${format}`); // Use formatted filename
  //         document.body.appendChild(link);
  //         link.click();
  //       } else if (format === "vnd.ms-excel") {
  //         // Generate Excel file
  //         const ws = XLSX.utils.json_to_sheet(exportData); // Convert JSON to sheet
  //         const wb = XLSX.utils.book_new(); // Create a new workbook
  //         XLSX.utils.book_append_sheet(wb, ws, "Users"); // Append sheet to workbook
  //         XLSX.writeFile(wb, `${filename}.xlsx`); // Use formatted filename
  //       } else if (format === "pdf") {
  //         // Generate PDF file
  //         const doc = new jsPDF();
  //         doc.text("Users Data", 20, 10);

  //         // Prepare data for PDF
  //         const headers = Object.keys(exportData[0]);
  //         const rows = exportData.map((row) =>
  //           headers.map((header) => row[header])
  //         );

  //         // Use autoTable for formatting
  //         doc.autoTable({
  //           head: [headers],
  //           body: rows,
  //         });

  //         doc.save(`${filename}.${format}`); // Use formatted filename
  //       }

  //       console.log(`Export as ${format} successful`);
  //     } else {
  //       console.error("No data available for export");
  //     }
  //   } catch (error) {
  //     setSeverity("error");
  //     setMessage(error?.response?.data?.message || error?.message);
  //     setOpenAlert(true);
  //     console.error("Export failed", error);
  //   }

  //   handleClose();
  // };

  return (
    <Layout>
      <Box sx={{ paddingBottom: "150px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "65vh",
            background: "#f0f3f6",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
            padding: "25px",
            borderRadius: "6px",
          }}
        >
          <Box
            sx={{
              background: "#ffffff",
              width: "443px",
              // p: 2,
              display: "flex",
              flexDirection: "column",
              gap: "15px",
              borderRadius: "16px",
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
            }}
          >
            <Box sx={{ p: 2 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  sx={{
                    width: { sx: "100%", md: "100% !important", xl: "100%" },
                  }}
                  components={["DatePicker"]}
                >
                  <DatePicker
                    sx={{
                      width: {
                        sx: "100%",
                        md: "100% !important",
                        xl: "100%",
                      },
                    }}
                    id="selectDate"
                    name="selectDate"
                    open={open}
                    onClose={() => setOpen(false)}
                    label="Select Date"
                    format="DD/MM/YYYY"
                    value={StartDate ? dayjs(StartDate) : null}
                    onChange={(date) => handleChangeDate(date)}
                    renderInput={(params) => (
                      <TextField {...params} error={false} helperText="" />
                    )}
                    slotProps={{
                      field: {
                        readOnly: true,
                      },
                      textField: {
                        onClick: () => setOpen(true),
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>

              <Box>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer
                    sx={{
                      width: { sx: "100%", md: "100% !important", xl: "100%" },
                    }}
                    components={["DatePicker"]}
                  >
                    <DatePicker
                      sx={{
                        width: {
                          sx: "100%",
                          md: "100% !important",
                          xl: "100%",
                        },
                      }}
                      id="endDate"
                      name="endDate"
                      open={openEnd}
                      onClose={() => setOpenEnd(false)}
                      label="End Date"
                      format="DD/MM/YYYY"
                      value={endDate ? dayjs(endDate) : null}
                      onChange={(date) => handleChangeDateEnd(date)}
                      renderInput={(params) => (
                        <TextField {...params} error={false} helperText="" />
                      )}
                      slotProps={{
                        field: {
                          readOnly: true,
                        },
                        textField: {
                          onClick: () => setOpenEnd(true),
                        },
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </Box>
            </Box>
            <Box sx={{ background: "#cfd5e0", height: "1px" }}></Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 2,
              }}
            >
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  value={selectedValue}
                  onChange={handleChangeRadio}
                >
                  <FormControlLabel
                    value="3"
                    control={<Radio />}
                    label="Last 3 months"
                  />
                  <FormControlLabel
                    value="6"
                    control={<Radio />}
                    label="Last 6 months"
                  />
                </RadioGroup>
              </FormControl>
            </Box>
            <Box sx={{ background: "#cfd5e0", height: "1px" }}></Box>

            <Box sx={{ p: 2 }}>
              {/* <TextField
                select
                id="role"
                label="Role"
                value={formData.role}
                name="role"
                onChange={handleChange}
                fullWidth
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      sx: {
                        maxHeight: 200, // Limit dropdown height
                      },
                    },
                  },
                }}
              >
                {roleOptions.map((option) => (
                  <MenuItem
                    sx={{
                      maxHeight: "30px !important", // Control the height of individual items
                      fontSize: "16px", // Adjust font size for compact display
                    }}
                    key={option.id}
                    value={option.value}
                  >
                    {option.value}
                  </MenuItem>
                ))}
              </TextField> */}
              <TextField
                select
                id="status"
                label="Status"
                name="status"
                value={formData.status}
                onChange={handleChange}
                fullWidth
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      sx: {
                        maxHeight: 200, // Limit dropdown height
                      },
                    },
                  },
                }}
              >
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
              </TextField>
              {/* {location.state == "role" ? (
                <Box sx={{mt:2}}>
                <TextField
                  select
                  id="globalLocal"
                  label="Global/Local"
                  name="globalLocal"
                  value={formData.globalLocal}
                  onChange={handleChange}
                  fullWidth
                  SelectProps={{
                    MenuProps: {
                      PaperProps: {
                        sx: {
                          maxHeight: 200, // Limit dropdown height
                        },
                      },
                    },
                  }}
                >
                  <MenuItem value="Global">Global</MenuItem>
                  <MenuItem value="Local">Local</MenuItem>
                </TextField>
                </Box>
              ) : (
                <></>
              )} */}
              {/* <TextField

                select
                multiple
                id="cropStageCountryDetail"
                label="Select Country"
                name="countryCode"
                value={formData.countryCode}
                onChange={handleChange}
                fullWidth
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      sx: {
                        maxHeight: 200, // Limit dropdown height
                      },
                    },
                  },
                }}
              >
                {countries.map((option) => (
                  <MenuItem
                    key={option.countryName}
                    value={option.countryCode}
                    sx={{
                      maxHeight: "30px !important", // Control the height of individual items
                      fontSize: "16px", // Adjust font size for compact display
                    }}
                  >
                    {option.countryName}
                  </MenuItem>
                ))}
              </TextField> */}
              <Box sx={{ mt: 2 }}>
                <FormControl fullWidth>
                  <InputLabel id="cropStageCountryDetail-label">
                    Country
                  </InputLabel>
                  <Select
                    labelId="cropStageCountryDetail-label"
                    name="cropStageCountryDetail"
                    label="Country"
                    multiple
                    value={selected}
                    onChange={handleChangeCountry}
                    renderValue={(selected) =>
                      selected.map((select) => select.countryName).join(", ")
                    }
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 250,
                          overflowY: "auto",
                        },
                      },
                    }}
                  >
                    {countries.map((option) => (
                      <MenuItem key={option.countryName} value={option}>
                        <ListItemIcon>
                          <Checkbox
                            checked={selected.indexOf(option) > -1}
                            icon={<img src={CheckboxUntick} />}
                            checkedIcon={<img src={CheckboxTick} />}
                          />
                        </ListItemIcon>
                        <ListItemText primary={option.countryName} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Box>
            <Box sx={{ background: "#cfd5e0", height: "1px" }}></Box>

            <>
              <Box
                sx={{
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  gap: "20px",
                  mt: "100px",
                  mb: "20px",
                }}
              >
                <Button
                  sx={{
                    borderRadius: 2,
                    background: "#102A62",
                    height: 54,
                    color: "#ffffff",
                    fontWeight: 600,
                    backgroundColor: "#737D86",
                    width: { xs: "100%", md: "156px" },
                    "&:hover": {
                      backgroundColor: "#737D86",
                    },
                  }}
                  onClick={() => navigate(-1)}
                >
                  Back
                </Button>
                <Button
                  ref={buttonRef}
                  sx={{
                    borderRadius: 2,
                    background: "#EF7D00",
                    color: "#ffffff",
                    fontWeight: 600,
                    height: 54,
                    width: { xs: "100%", md: "156px" },
                    "&:hover": {
                      backgroundColor: "#EF7D00",
                    },
                  }}
                  onClick={handleClick}
                >
                  Export
                </Button>
                <Menu
                  anchorEl={anchorEl}
                  open={openMenu}
                  onClose={handleCloseMenu}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  PaperProps={{
                    sx: {
                      width: buttonRef.current
                        ? buttonRef.current.offsetWidth
                        : "auto",
                    },
                  }}
                >
                  <MenuItem onClick={() => handleExport("vnd.ms-excel")}>
                    Excel
                  </MenuItem>
                  <MenuItem onClick={() => handleExport("csv")}>CSV</MenuItem>
                  <MenuItem onClick={() => handleExport("pdf")}>PDF</MenuItem>
                </Menu>
              </Box>
            </>
          </Box>
        </Box>
      </Box>
    </Layout>
  );
};

export default Export;
